import { useState } from 'react';
import { useFirebase } from 'v3/hooks/useFirebase';
import { BodySmallBold } from 'v3/shared/typography/BodySmall';
import { AssureModal } from '../../Modal/AssureModal';
import { Container, LogoutContainer, LogoutIconStyled } from './styles';

export const LogoutButton = () => {
  const { logout } = useFirebase();
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);

  return (
    <Container>
      <LogoutContainer onClick={() => setLogoutModalOpen(true)}>
        <LogoutIconStyled />
        <BodySmallBold>Sair</BodySmallBold>
      </LogoutContainer>

      <AssureModal
        modal={{
          title: 'Deseja encerrar sess\u00E3o?',
          subtitle: 'Se sair agora, precisar\u00E1 fazer login novamente.',
          activeButton: true,
          agreeButton: 'Encerrar',
          disagreeButton: 'N\u00E3o encerrar',
          active: logoutModalOpen,
        }}
        onClose={() => setLogoutModalOpen(false)}
        onConfirm={() => {
          logout();
          setLogoutModalOpen(false);
          window.location.reload();
        }}
      />
    </Container>
  );
};
